// client/src/flow/examples/ugitsExample.js

export const UGITS_EXAMPLE = {
  name: "UGITS - Unidade de Gestão da Inovação Tecnológica em Saúde",
  url: "ugits",
  type: "navigation",
  logo: null, // Usa o componente UgitsLogo
  formConfig: {
    title: "UGITS - Unidade de Gestão da Inovação Tecnológica em Saúde",
    subtitle: "HC-UFU/EBSERH - Facilitador de Acesso à Informação\n⚠️ PROTÓTIPO EXPERIMENTAL",
    urgentPhone: "",
    email: "",
    successMessage: "",
    settings: {
      showProgressBar: false,
      requireConfirmation: false,
      generateProtocol: false,
      sendEmail: false,
      navigationMode: "tree"
    },
    steps: [
      // NÍVEL 0 - Principal
      {
        id: "home",
        title: "UGITS - Facilitador de Acesso",
        icon: "Zap",
        type: "navigation",
        level: 0,
        showBreadcrumbs: false,
        showAISearch: true,
        fields: [
          {
            id: "disclaimer-info",
            type: "info",
            label: "⚠️ Protótipo Experimental",
            description: "Este é um PROTÓTIPO facilitador para acessar informações frequentemente consultadas do HC-UFU/EBSERH. NÃO substitui os canais oficiais. Para informações completas, sempre consulte os sites oficiais.",
            icon: "AlertCircle"
          },
          {
            id: "main-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              // NOVO BOTÃO PRINCIPAL - VOLUNTARIADO
              {
                id: "volunteer-innovation",
                type: "navigate",
                label: "🤝 Seja Voluntário em Inovação",
                description: "Contribua com projetos de inovação!\nPodcast, NATS, Apps, Mapeamento\nTemos várias oportunidades!",
                emoji: "💚",
                targetStep: "volunteer-main",
                variant: "primary",
                badge: "NOVO!",
                style: {
                  backgroundColor: "#059669",
                  color: "white"
                }
              },
              {
                id: "pit-program",
                type: "navigate",
                label: "PIT - Programa de Inovação",
                description: "Programa de fomento à inovação tecnológica\n3º Ciclo em andamento\nBolsas e mentoria disponíveis",
                emoji: "🚀",
                targetStep: "pit-main",
                variant: "primary"
              },
              {
                id: "nats-evaluation",
                type: "navigate",
                label: "NATS - Avaliação de Tecnologias",
                description: "Núcleo de Avaliação de Tecnologias em Saúde\nAnálise custo-efetividade\nPareceres técnicos",
                emoji: "🔬",
                targetStep: "nats-main",
                variant: "success"
              },
              {
                id: "digital-tools",
                type: "navigate",
                label: "Ferramentas Digitais",
                description: "Soluções desenvolvidas pela UGITS\nAVAQualis, DeuMatch, ID-HC\nAssistente Digital",
                emoji: "🛠️",
                targetStep: "ferramentas-main",
                variant: "info"
              },
              {
                id: "redcap-system",
                type: "navigate",
                label: "REDCap",
                description: "Sistema de coleta eletrônica de dados\nServidor EBSERH seguro\nBackup diário automático",
                emoji: "📊",
                targetStep: "redcap-main",
                variant: "warning"
              },
              {
                id: "intellectual-property",
                type: "navigate",
                label: "Propriedade Intelectual",
                description: "Registro de patentes e software\nOrientação INPI\nProteção de inovações",
                emoji: "🏆",
                targetStep: "propriedade-main"
              },
              {
                id: "mentoring",
                type: "navigate",
                label: "Mentorias Especializadas",
                description: "Programa conjunto UGITS + UGPESQ\nOrientação metodológica\nConsultoria estatística",
                emoji: "👨‍🏫",
                targetStep: "mentorias-main",
                badge: "Parceria UGPESQ"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: false,
          showNext: false,
          showHome: false
        }
      },

      // NOVA PÁGINA - VOLUNTARIADO
      {
        id: "volunteer-main",
        title: "Seja Voluntário em Inovação 🤝",
        description: "Junte-se a nós e contribua com projetos inovadores!",
        icon: "Heart",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "volunteer-info",
            type: "info",
            label: "💚 Oportunidades de Voluntariado",
            description: "A UGITS está buscando voluntários apaixonados por inovação para contribuir em diversos projetos. Não importa sua área de formação - o que vale é o entusiasmo e vontade de fazer a diferença!",
            icon: "Heart"
          },
          {
            id: "volunteer-note",
            type: "info",
            label: "📱 Observação sobre Atendimento",
            description: "A UGITS atende via WhatsApp compartilhado com a UGPESQ no número (34) 3218-2323. Todas as mensagens serão respondidas pela equipe conjunta.",
            icon: "Info"
          },
          {
            id: "volunteer-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "volunteer-podcast",
                type: "contact",
                label: "🎙️ Podcast HChange",
                description: "Ajude a reativar!\n• Edição de áudio\n• Roteiros e pautas\n• Co-hosting",
                emoji: "🎙️",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🎙️%0A%0ATenho%20interesse%20em%20ser%20*voluntário*%20para%20ajudar%20na%20reativação%20do%20*Podcast%20HChange*!%0A%0A👤%20*Sobre%20mim:*%0A•%20Nome:%20%0A•%20Formação:%20%0A•%20Experiência%20com%20podcasts/áudio:%20%0A%0A💡%20*Posso%20contribuir%20com:*%0A[%20]%20Edição%20de%20áudio%0A[%20]%20Criação%20de%20roteiros%0A[%20]%20Desenvolvimento%20de%20pautas%0A[%20]%20Co-hosting/apresentação%0A[%20]%20Design%20de%20capas%0A[%20]%20Divulgação%0A[%20]%20Outro:%20%0A%0A📅%20*Disponibilidade:*%0A•%20Horas%20por%20semana:%20%0A•%20Período:%20[Manhã]%20[Tarde]%20[Noite]%0A%0AVamos%20conversar?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "volunteer-nats",
                type: "contact",
                label: "🔬 NATS - Avaliação",
                description: "Participe do núcleo!\n• Análise de tecnologias\n• Pareceres técnicos\n• Pesquisa",
                emoji: "🔬",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🔬%0A%0ATenho%20interesse%20em%20ser%20*voluntário*%20no%20*NATS*%20-%20Núcleo%20de%20Avaliação%20de%20Tecnologias!%0A%0A👤%20*Sobre%20mim:*%0A•%20Nome:%20%0A•%20Formação:%20%0A•%20Área%20de%20expertise:%20%0A%0A💡%20*Posso%20contribuir%20com:*%0A[%20]%20Análise%20de%20custo-efetividade%0A[%20]%20Revisões%20sistemáticas%0A[%20]%20Pareceres%20técnicos%0A[%20]%20Avaliação%20de%20tecnologias%0A[%20]%20Pesquisa%20científica%0A[%20]%20Outro:%20%0A%0A📚%20*Experiência%20prévia:*%0A%0A📅%20*Disponibilidade:*%0A•%20Horas%20por%20semana:%20%0A%0AVamos%20conversar?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "volunteer-deumatch",
                type: "contact",
                label: "💑 DeuMatchNaPesquisa",
                description: "Ajude a reativar!\n• Desenvolvimento\n• Design UX/UI\n• Marketing",
                emoji: "💑",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20💑%0A%0ATenho%20interesse%20em%20ser%20*voluntário*%20para%20reativar%20o%20*DeuMatchNaPesquisa*!%0A%0A👤%20*Sobre%20mim:*%0A•%20Nome:%20%0A•%20Formação:%20%0A•%20Habilidades%20técnicas:%20%0A%0A💻%20*Posso%20contribuir%20com:*%0A[%20]%20Desenvolvimento%20(frontend/backend)%0A[%20]%20Design%20UX/UI%0A[%20]%20Banco%20de%20dados%0A[%20]%20Marketing%20digital%0A[%20]%20Criação%20de%20conteúdo%0A[%20]%20Testes%20e%20QA%0A[%20]%20Outro:%20%0A%0A🛠️%20*Tecnologias%20que%20domino:*%0A%0A📅%20*Disponibilidade:*%0A•%20Horas%20por%20semana:%20%0A%0AVamos%20conversar?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "volunteer-quizito",
                type: "contact",
                label: "🎯 Quizito.App",
                description: "Nova plataforma!\n• Quiz interativos\n• Gamificação\n• Educação",
                emoji: "🎯",
                badge: "Novo Projeto",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🎯%0A%0ATenho%20interesse%20em%20ser%20*voluntário*%20no%20*Quizito.App*%20-%20plataforma%20de%20quiz%20interativos!%0A%0A👤%20*Sobre%20mim:*%0A•%20Nome:%20%0A•%20Formação:%20%0A•%20Experiência%20com%20educação/gamificação:%20%0A%0A💡%20*Posso%20contribuir%20com:*%0A[%20]%20Criação%20de%20conteúdo%0A[%20]%20Design%20de%20quiz%0A[%20]%20Desenvolvimento%0A[%20]%20Testes%20de%20usabilidade%0A[%20]%20Marketing%0A[%20]%20Outro:%20%0A%0A🎮%20*Ideias%20para%20o%20projeto:*%0A%0A📅%20*Disponibilidade:*%0A•%20Horas%20por%20semana:%20%0A%0AVamos%20conversar?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "volunteer-mapping",
                type: "contact",
                label: "🗺️ Mapeamento de Inovações",
                description: "Catalogação HC-UFU!\n• Identificar inovações\n• Documentar processos\n• Registros",
                emoji: "🗺️",
                badge: "Estratégico",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🗺️%0A%0ATenho%20interesse%20em%20ser%20*voluntário*%20no%20*Mapeamento%20de%20Inovações*%20do%20HC-UFU!%0A%0A👤%20*Sobre%20mim:*%0A•%20Nome:%20%0A•%20Formação:%20%0A•%20Setor/Departamento:%20%0A%0A💡%20*Posso%20contribuir%20com:*%0A[%20]%20Identificação%20de%20inovações%0A[%20]%20Entrevistas%20com%20equipes%0A[%20]%20Documentação%20de%20processos%0A[%20]%20Catalogação%20e%20organização%0A[%20]%20Análise%20de%20dados%0A[%20]%20Redação%20de%20relatórios%0A[%20]%20Outro:%20%0A%0A🔍%20*Já%20identifiquei%20inovações%20em:*%0A%0A📅%20*Disponibilidade:*%0A•%20Horas%20por%20semana:%20%0A%0AVamos%20conversar?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "volunteer-other",
                type: "contact",
                label: "💡 Tenho Outra Ideia!",
                description: "Proponha algo novo!\n• Sua ideia inovadora\n• Novo projeto\n• Parceria",
                emoji: "💡",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20💡%0A%0ATenho%20uma%20*ideia%20inovadora*%20e%20gostaria%20de%20ser%20*voluntário*%20na%20UGITS!%0A%0A👤%20*Sobre%20mim:*%0A•%20Nome:%20%0A•%20Formação:%20%0A•%20Área%20de%20atuação:%20%0A%0A💭%20*Minha%20ideia:*%0A•%20Nome%20do%20projeto:%20%0A•%20Problema%20que%20resolve:%20%0A•%20Como%20funcionaria:%20%0A•%20Público-alvo:%20%0A%0A🚀%20*Por%20que%20é%20inovador:*%0A%0A🤝%20*Como%20posso%20contribuir:*%0A%0A📅%20*Disponibilidade:*%0A•%20Horas%20por%20semana:%20%0A%0AVamos%20conversar?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // NÍVEL 1 - PIT Principal
      {
        id: "pit-main",
        title: "PIT - Programa de Inovação Tecnológica",
        description: "3º Ciclo em andamento",
        icon: "Rocket",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "pit-info",
            type: "info",
            label: "Programa em seu 3º Ciclo",
            description: "Atualmente em fase de seleção e com previsão para início em Setembro'25",
            icon: "Trophy"
          },
          {
            id: "pit-whatsapp-note",
            type: "info",
            label: "📱 Observação sobre WhatsApp",
            description: "A UGITS atende via WhatsApp compartilhado com a UGPESQ no número (34) 3218-2323",
            icon: "MessageCircle"
          },
          {
            id: "pit-details",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "pit-sobre",
                type: "link",
                label: "Sobre o PIT - Site Oficial",
                description: "História, projetos aprovados e resultados",
                emoji: "📖",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/unidade-de-gestao-da-inovacao-tecnologica-em-saude/pit-hc-ufu"
              },
              {
                id: "pit-inscricao",
                type: "contact",
                label: "Como Participar do PIT",
                description: "Processo seletivo e bolsas",
                emoji: "📝",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20💡%0A%0ATenho%20interesse%20no%20*PIT%20-%20Programa%20de%20Inovação%20Tecnológica*.%0A%0A🚀%20*Sobre%20minha%20ideia/projeto:*%0A•%20Nome%20do%20projeto:%20%0A•%20Área%20de%20aplicação:%20%0A•%20Problema%20que%20resolve:%20%0A•%20Estágio%20atual:%20[Ideia]%20[Protótipo]%20[MVP]%20[Produto]%0A%0A📋%20*Preciso%20de%20informações%20sobre:*%0A[%20]%20Como%20participar%20do%20programa%0A[%20]%20Critérios%20de%20seleção%0A[%20]%20Apoio%20oferecido%0A[%20]%20Próximas%20chamadas%0A[%20]%20Mentorias%20disponíveis%0A%0APodemos%20agendar%20uma%20conversa?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "pit-mentoria",
                type: "contact",
                label: "Mentoria para Projetos",
                description: "Design thinking e prototipagem",
                emoji: "💡",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20💡%0A%0APreciso%20de%20mentoria%20para%20meu%20projeto%20de%20inovação.%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // NÍVEL 1 - NATS Principal (com botão de voluntariado)
      {
        id: "nats-main",
        title: "NATS - Núcleo de Avaliação de Tecnologias em Saúde",
        description: "Avaliação baseada em evidências",
        icon: "Search",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "nats-info",
            type: "info",
            label: "Portaria SEI nº 131/2025",
            description: "10 membros especialistas. Coordenação: Marcelo Batista Chioato dos Santos.",
            icon: "Shield"
          },
          {
            id: "nats-volunteer-info",
            type: "info",
            label: "🤝 Buscamos Voluntários!",
            description: "O NATS está aberto a voluntários interessados em contribuir com avaliação de tecnologias em saúde. Junte-se a nós!",
            icon: "Heart"
          },
          {
            id: "nats-details",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "nats-sobre",
                type: "link",
                label: "Sobre o NATS",
                description: "Composição e atividades",
                emoji: "👥",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/unidade-de-gestao-da-inovacao-tecnologica-em-saude/nats"
              },
              {
                id: "nats-volunteer",
                type: "contact",
                label: "🤝 Seja Voluntário no NATS",
                description: "Contribua com análises e pareceres técnicos",
                emoji: "💚",
                badge: "Voluntariado",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🔬%0A%0ATenho%20interesse%20em%20ser%20*voluntário*%20no%20*NATS*.%0A%0A👤%20*Sobre%20mim:*%0A•%20Nome:%20%0A•%20Formação:%20%0A•%20Área%20de%20expertise:%20%0A%0A💡%20*Posso%20contribuir%20com:*%0A[%20]%20Análise%20de%20custo-efetividade%0A[%20]%20Revisões%20sistemáticas%0A[%20]%20Pareceres%20técnicos%0A[%20]%20Outro:%20%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "nats-solicitar",
                type: "contact",
                label: "Solicitar Avaliação",
                description: "Submeter tecnologias para análise",
                emoji: "📋",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🔍%0A%0AGostaria%20de%20saber%20mais%20sobre%20o%20*NATS%20-%20Núcleo%20de%20Avaliação%20de%20Tecnologias%20em%20Saúde*.%0A%0A📊%20*Tenho%20interesse%20em:*%0A[%20]%20Submeter%20tecnologia%20para%20avaliação%0A[%20]%20Conhecer%20tecnologias%20já%20avaliadas%0A[%20]%20Solicitar%20parecer%20técnico%0A[%20]%20Outro:%20%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AAtenciosamente,",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // Restante das páginas com observações de WhatsApp adicionadas...
      // NÍVEL 1 - Ferramentas Digitais
      {
        id: "ferramentas-main",
        title: "Ferramentas Digitais Desenvolvidas",
        description: "Soluções tecnológicas",
        icon: "Package",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "ferramentas-volunteer-info",
            type: "info",
            label: "🤝 Várias ferramentas precisam de voluntários!",
            description: "DeuMatch, Podcast HChange e outras iniciativas estão buscando colaboradores. Veja abaixo e participe!",
            icon: "Heart"
          },
          {
            id: "ferramentas-list",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "assistente-pesquisa",
                type: "link",
                label: "Assistente Digital",
                description: "Estruturação de perguntas PICO e outros",
                emoji: "🤖",
                url: "https://biblioteca-hc-ufu.vercel.app",
                badge: "Parceria Biblioteca",
                variant: "success"
              },
              {
                id: "avaqualis",
                type: "navigate",
                label: "AVAQualis.com",
                description: "Ferramenta mobile para acreditação",
                emoji: "📱",
                targetStep: "avaqualis-details",
                status: "pilot"
              },
              {
                id: "deumatch",
                type: "navigate",
                label: "DeuMatchNaPesquisa",
                description: "Conecta estudantes e pesquisadores\n🤝 Precisamos de voluntários!",
                emoji: "💑",
                targetStep: "deumatch-details",
                status: "suspended",
                statusMessage: "⚠️ Reativando - Precisamos de você!",
                badge: "Voluntários"
              },
              {
                id: "id-hc",
                type: "navigate",
                label: "ID-HC",
                description: "Identificação digital religiosos",
                emoji: "🆔",
                targetStep: "idhc-details",
                status: "coming-soon"
              },
              {
                id: "quizito-app",
                type: "contact",
                label: "Quizito.App",
                description: "Crie Quiz Interativos Gratuitamente!\n🤝 Nova iniciativa - seja voluntário!",
                emoji: "🎯",
                badge: "NOVO!",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🎯%0A%0ATenho%20interesse%20no%20*Quizito.App*%20-%20a%20nova%20plataforma%20de%20quiz%20interativos!%0A%0A💡%20Gostaria%20de:%0A[%20]%20Conhecer%20mais%20sobre%20o%20projeto%0A[%20]%20Ser%20voluntário%0A[%20]%20Usar%20a%20plataforma%0A[%20]%20Propor%20parceria%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "formulario-inovacao",
                type: "contact",
                label: "Formulário de Monitoramento",
                description: "Informe ações inovadoras",
                emoji: "📝",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20📝%0A%0AGostaria%20de%20saber%20mais%20sobre%20o%20*Formulário%20de%20Monitoramento*%20para%20informar%20ações%20inovadoras.%0A%0AComo%20posso%20contribuir%20ou%20obter%20acesso%20a%20ele?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "podcast-hchange",
                type: "navigate",
                label: "Podcast HChange",
                description: "Comunicação científica\n🤝 Ajude a reativar - precisamos de editores!",
                emoji: "🎙️",
                status: "suspended",
                statusMessage: "Suspenso - Buscando voluntários!",
                targetStep: "podcast-details",
                badge: "Voluntários"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // NÍVEL 2 - Podcast Details (com chamada para voluntários)
      {
        id: "podcast-details",
        title: "Podcast HChange",
        description: "Comunicação científica temporariamente suspensa.\n\n🤝 PRECISAMOS DE VOCÊ!",
        icon: "Mic",
        type: "navigation",
        level: 2,
        parentStep: "ferramentas-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "podcast-volunteer-alert",
            type: "info",
            label: "🎙️ Ajude a Reativar o Podcast!",
            description: "Temos episódios planejados e conteúdo pronto, mas precisamos de voluntários para edição de áudio, criação de pautas e co-hosting. Sua contribuição pode fazer a diferença!",
            icon: "Heart"
          },
          {
            id: "podcast-actions",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "access-podcast",
                type: "link",
                label: "Ouvir Episódios Anteriores",
                description: "Acesse a página oficial para ouvir os episódios já publicados.",
                emoji: "🎧",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/podcast-hchange"
              },
              {
                id: "collaborate-podcast",
                type: "contact",
                label: "🤝 QUERO SER VOLUNTÁRIO!",
                description: "Tem habilidades em áudio? Quer ser co-host? Tem ideias de pautas? Venha fazer parte!",
                emoji: "💚",
                badge: "URGENTE!",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🎙️%0A%0A*QUERO%20SER%20VOLUNTÁRIO*%20para%20reativar%20o%20Podcast%20HChange!%0A%0A👤%20*Sobre%20mim:*%0A•%20Nome:%20%0A•%20Formação:%20%0A%0A💡%20*Posso%20ajudar%20com:*%0A[%20]%20Edição%20de%20áudio%0A[%20]%20Criação%20de%20pautas%0A[%20]%20Co-hosting/apresentação%0A[%20]%20Design%20de%20capas%0A[%20]%20Transcrição%0A[%20]%20Divulgação%0A[%20]%20Outro:%20%0A%0A🎯%20*Experiência%20prévia:*%0A%0A📅%20*Disponibilidade:*%0A•%20Horas%20por%20semana:%20%0A%0AVamos%20reativar%20esse%20projeto%20juntos!%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // NÍVEL 2 - DeuMatch Details (com chamada para voluntários)
      {
        id: "deumatch-details",
        title: "DeuMatchNaPesquisa",
        description: "Conecta estudantes e pesquisadores\n\n🤝 PRECISAMOS DE DESENVOLVEDORES!",
        icon: "Users",
        type: "navigation",
        level: 2,
        parentStep: "ferramentas-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "deumatch-volunteer-alert",
            type: "info",
            label: "💑 Ajude a Reativar a Plataforma!",
            description: "O DeuMatch tem potencial para revolucionar a conexão entre pesquisadores e estudantes. Precisamos de desenvolvedores, designers e marketers voluntários!",
            icon: "Heart"
          },
          {
            id: "deumatch-actions",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "access-deumatch",
                type: "link",
                label: "Acessar a Aplicação",
                description: "Visite o site oficial do DeuMatchNaPesquisa.com",
                emoji: "🌐",
                url: "https://deumatchnapesquisa.com/"
              },
              {
                id: "volunteer-deumatch",
                type: "contact",
                label: "🤝 SEJA VOLUNTÁRIO!",
                description: "Desenvolvedor? Designer? Tem ideias? Venha reativar conosco!",
                emoji: "💚",
                badge: "PRECISAMOS DE VOCÊ!",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20💑%0A%0A*QUERO%20SER%20VOLUNTÁRIO*%20para%20reativar%20o%20DeuMatchNaPesquisa!%0A%0A👤%20*Sobre%20mim:*%0A•%20Nome:%20%0A•%20Formação:%20%0A%0A💻%20*Posso%20contribuir%20com:*%0A[%20]%20Desenvolvimento%20Frontend%0A[%20]%20Desenvolvimento%20Backend%0A[%20]%20Design%20UX/UI%0A[%20]%20Banco%20de%20dados%0A[%20]%20Marketing%20digital%0A[%20]%20Testes%0A[%20]%20Outro:%20%0A%0A🛠️%20*Tecnologias%20que%20domino:*%0A%0A📅%20*Disponibilidade:*%0A•%20Horas%20por%20semana:%20%0A%0AVamos%20reativar%20essa%20plataforma%20incrível!%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // Restante das páginas com observações de WhatsApp...
      // NÍVEL 2 - AVAQualis Details
      {
        id: "avaqualis-details",
        title: "AVAQualis.com",
        description: "Ferramenta mobile para acreditação\n\n🧪 Em fase piloto",
        icon: "Smartphone",
        type: "navigation",
        level: 2,
        parentStep: "ferramentas-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "avaqualis-actions",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "access-avaqualis",
                type: "link",
                label: "Acessar a Aplicação",
                description: "Visite o site oficial do AVAQualis.com",
                emoji: "🌐",
                url: "https://avaqualis.com/"
              },
              {
                id: "contact-avaqualis",
                type: "contact",
                label: "Saber Mais",
                description: "Entre em contato para detalhes sobre o projeto piloto",
                emoji: "❓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20📱%0A%0AGostaria%20de%20saber%20mais%20sobre%20o%20AVAQualis.com,%20a%20ferramenta%20mobile%20para%20acreditação.%0A%0A🧪%20Como%20está%20a%20fase%20piloto?%20Como%20posso%20participar?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // NÍVEL 2 - ID-HC Details
      {
        id: "idhc-details",
        title: "ID-HC",
        description: "Identificação digital para visitadores religiosos\n\n🔜 Em breve",
        icon: "UserCheck",
        type: "navigation",
        level: 2,
        parentStep: "ferramentas-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "idhc-actions",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "access-idhc",
                type: "link",
                label: "Acessar a Aplicação",
                description: "Visite o site oficial do ID-HC.com",
                emoji: "🌐",
                url: "https://id-hc.com/"
              },
              {
                id: "contact-idhc",
                type: "contact",
                label: "Saber Mais",
                description: "Entre em contato para saber sobre o lançamento",
                emoji: "❓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182064&text=Olá%20Capelania!%20🙏%0A%0AFiquei%20sabendo%20sobre%20o%20*ID-HC*%20-%20Sistema%20de%20Identificação%20Digital%20para%20visitadores%20religiosos.%20Gostaria%20de%20mais%20informações%20sobre%20o%20lançamento%20e%20como%20fazer%20o%20cadastro%20antecipado.%0A%0AMeu%20nome%20é:%20%0AMinha%20instituição%20religiosa%20é:%20%0A%0AObrigado!",
                  email: "capelaniahos.hc-ufu@ebserh.gov.br",
                  phone: "(34) 3218-2064"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // NÍVEL 1 - REDCap (com observação WhatsApp)
      {
        id: "redcap-main",
        title: "REDCap - Research Electronic Data Capture",
        description: "Sistema de coleta de dados",
        icon: "Database",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "redcap-whatsapp-note",
            type: "info",
            label: "📱 Observação sobre Atendimento",
            description: "A UGITS atende via WhatsApp compartilhado com a UGPESQ no número (34) 3218-2323",
            icon: "MessageCircle"
          },
          {
            id: "redcap-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "redcap-acesso",
                type: "link",
                label: "Acessar REDCap",
                description: "Portal institucional EBSERH",
                emoji: "💻",
                url: "https://redcap.ebserh.gov.br"
              },
              {
                id: "redcap-solicitar",
                type: "contact",
                label: "Solicitar Acesso",
                description: "Criar conta para novo projeto",
                emoji: "🔐",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🔐%0A%0AGostaria%20de%20solicitar%20*acesso%20ao%20REDCap*%20para%20meu%20projeto%20de%20pesquisa.%0A%0A📋%20*Dados%20do%20pesquisador:*%0A•%20Nome%20completo:%20%0A•%20CPF:%20%0A•%20Email%20institucional:%20%0A•%20Vínculo%20com%20HC-UFU:%20%0A%0A🔬%20*Sobre%20o%20projeto:*%0A•%20Título:%20%0A•%20Pesquisador%20principal:%20%0A•%20Número%20CEP%20(se%20houver):%20%0A•%20Previsão%20de%20coleta:%20%0A%0A📊%20*Necessidades:*%0A[%20]%20Criar%20novo%20projeto%0A[%20]%20Acessar%20projeto%20existente%0A[%20]%20Treinamento%20básico%0A[%20]%20Suporte%20avançado%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "redcap-treinamento",
                type: "contact",
                label: "Treinamento REDCap",
                description: "Capacitação básica e avançada",
                emoji: "🎓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🎓%0A%0APreciso%20de%20*treinamento%20no%20REDCap*.%0A%0A📚%20*Nível%20de%20conhecimento:*%0A[%20]%20Nunca%20usei%20o%20REDCap%0A[%20]%20Uso%20básico%0A[%20]%20Intermediário%0A%0A🎯%20*Preciso%20aprender:*%0A[%20]%20Criar%20formulários%0A[%20]%20Importar/exportar%20dados%0A[%20]%20Criar%20relatórios%0A[%20]%20Configurar%20alertas%0A[%20]%20Branching%20logic%0A[%20]%20Calculated%20fields%0A[%20]%20API%0A%0A📅%20*Disponibilidade:*%0A•%20Manhã%20[%20]%20Tarde%20[%20]%0A•%20Dias%20preferenciais:%20%0A%0AQuantas%20pessoas%20do%20meu%20grupo%20precisam:%20%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // NÍVEL 1 - Propriedade Intelectual (com observação WhatsApp)
      {
        id: "propriedade-main",
        title: "Propriedade Intelectual",
        description: "Proteção de inovações",
        icon: "Award",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "propriedade-whatsapp-note",
            type: "info",
            label: "📱 Observação sobre Atendimento",
            description: "A UGITS atende via WhatsApp compartilhado com a UGPESQ no número (34) 3218-2323",
            icon: "MessageCircle"
          },
          {
            id: "propriedade-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "registro-software",
                type: "link",
                label: "Registro de Software",
                description: "Fluxograma completo INPI",
                emoji: "💻",
                url: "https://www.gov.br/ebserh/pt-br/ensino-e-pesquisa/inovacao/propriedade-intelectual/anexo-i_como-solicitar-registro-de-um-software.pdf"
              },
              {
                id: "registro-marca",
                type: "link",
                label: "Registro de Marca",
                description: "Processo de registro INPI",
                emoji: "™️",
                url: "https://www.gov.br/ebserh/pt-br/ensino-e-pesquisa/inovacao/propriedade-intelectual/anexo-ii_como-solicitar-registro-de-uma-marca.pdf"
              },
              {
                id: "registro-patente",
                type: "contact",
                label: "Registro de Patente",
                description: "Orientação sem fluxo oficial",
                emoji: "🏆",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🏆%0A%0ATenho%20uma%20invenção%20e%20gostaria%20de%20informações%20sobre%20*Registro%20de%20Patente*.%0A%0A💡%20*Sobre%20a%20invenção:*%0A•%20Área:%20%0A•%20Problema%20que%20resolve:%20%0A•%20Diferencial%20inovador:%20%0A%0A🔍%20*Status%20atual:*%0A[%20]%20Ideia%20conceitual%0A[%20]%20Protótipo%20funcional%0A[%20]%20Testes%20realizados%0A[%20]%20Pronto%20para%20produção%0A%0A📋%20*Dúvidas:*%0A[%20]%20Busca%20de%20anterioridade%0A[%20]%20Redação%20da%20patente%0A[%20]%20Custos%20do%20processo%0A[%20]%20Tempo%20de%20análise%0A[%20]%20Comercialização%0A%0APodemos%20conversar%20melhor?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AAtenciosamente,",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "portal-pi",
                type: "link",
                label: "Portal PI EBSERH",
                description: "Portal completo Rede EBSERH",
                emoji: "📚",
                url: "https://www.gov.br/ebserh/pt-br/ensino-e-pesquisa/inovacao/propriedade-intelectual"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },

      // NÍVEL 1 - Mentorias (com observação WhatsApp)
      {
        id: "mentorias-main",
        title: "Mentorias Especializadas",
        description: "Programa conjunto UGITS + UGPESQ",
        icon: "Users",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "mentorias-info",
            type: "info",
            label: "Serviço Compartilhado",
            description: "Oferecido em parceria entre UGITS e UGPESQ",
            icon: "Info"
          },
          {
            id: "mentorias-whatsapp-note",
            type: "info",
            label: "📱 Observação sobre Atendimento",
            description: "A UGITS atende via WhatsApp compartilhado com a UGPESQ no número (34) 3218-2323",
            icon: "MessageCircle"
          },
          {
            id: "mentorias-list",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "mentoria-pesquisa",
                type: "contact",
                label: "Mentoria em Pesquisa",
                description: "Roberto Ranza e Francisco Neto\nBloco 8F",
                emoji: "🎓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20👋%0A%0AVi%20no%20UGITS%20que%20vocês%20oferecem%20*Mentoria%20em%20Pesquisa*.%0A%0A📅%20Vi%20que%20os%20horários%20disponíveis%20são:%0A•%20Segundas%208h-9h30%0A•%20Terças%2013h-14h30%0A%0AGostaria%20de%20reservar%20um%20horário%20para%20discutir%20meu%20projeto%20de%20pesquisa.%0A%0A📝%20*Meus%20dados:*%0A•%20Nome:%20%0A•%20Vínculo%20com%20o%20HC:%20%0A•%20Área%20da%20pesquisa:%20%0A•%20Principal%20dúvida:%20%0A%0A📍%20Local:%20Bloco%208F%20-%20Campus%20Umuarama%0A%0APor%20favor,%20me%20informem%20qual%20data%20teria%20disponibilidade.%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AAguardo%20retorno.%20Obrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br",
                  address: "Bloco 8F - Campus Umuarama",
                  hours: "Seg 8h-9h30 | Ter 13h-14h30"
                }
              },
              {
                id: "mentoria-estatistica",
                type: "contact",
                label: "Consultoria Estatística",
                description: "Profa. Nadia Biase (IME/UFU)",
                emoji: "📊",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20📊%0A%0AVi%20que%20a%20*Profa.%20Nadia%20Giaretta%20Biase*%20oferece%20consultoria%20estatística%20às%20terças%20à%20tarde.%0A%0A📈%20*Meu%20projeto:*%0A•%20Área:%20%0A•%20Tipo%20de%20estudo:%20%0A•%20Tamanho%20amostral:%20%0A•%20Status:%20[Planejamento]%20[Coleta]%20[Análise]%0A%0A🎯%20*Preciso%20de%20ajuda%20com:*%0A[%20]%20Cálculo%20amostral%0A[%20]%20Plano%20de%20análise%0A[%20]%20Escolha%20de%20testes%0A[%20]%20Interpretação%20de%20resultados%0A[%20]%20Software%20estatístico%0A[%20]%20Outro:%20%0A%0A💻%20*Uso/pretendo%20usar:*%0A[%20]%20SPSS%0A[%20]%20R%0A[%20]%20SAS%0A[%20]%20Stata%0A[%20]%20Excel%0A%0APosso%20agendar%20uma%20consultoria?%0A%0A📱%20*Obs:*%20A%20UGITS%20atende%20via%20WhatsApp%20compartilhado%20com%20a%20UGPESQ.%0A%0AObrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br",
                  hours: "Terças à tarde (agendamento)"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      }
    ]
  },
  theme: {
    primaryColor: "#6D28D9",
    primaryColorHover: "#5B21B6",
    secondaryColor: "#059669",
    secondaryColorHover: "#047857",
    pageBackground: "#f3f4f6",
    cardBackground: "#ffffff",
    inputBackground: "#ffffff",
    textPrimary: "#1f2937",
    textSecondary: "#6b7280",
    textOnPrimary: "#ffffff",
    textOnSecondary: "#ffffff",
    borderColor: "#e5e7eb",
    borderRadius: "16px",
    errorColor: "#dc2626",
    successColor: "#059669",
    warningColor: "#f59e0b",
    infoColor: "#3b82f6",
    buttonStyle: "rounded",
    buttonPadding: "16px 32px",
    buttonFontWeight: "700",
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: "16px",
    headingFontFamily: '"Inter", sans-serif',
    headingFontWeight: "800",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    boxShadowHover: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    transitionDuration: "0.3s",
    progressBarColor: "linear-gradient(90deg, #6D28D9 0%, #059669 100%)",
    progressBarBackground: "#e5e7eb",
    logoBackground: "transparent",
    logoPadding: "16px",
    logoBorderRadius: "12px"
  }
};